import { render, staticRenderFns } from "./CommentWithLikes.vue?vue&type=template&id=4f5cd3be"
import script from "./CommentWithLikes.vue?vue&type=script&lang=js"
export * from "./CommentWithLikes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports